import ApiService from "@/common/api.service";

const getFileNameFromDisposition = (header = "") => {
  if (!header) return null;
  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf8Match && utf8Match[1]) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch (error) {
      return utf8Match[1];
    }
  }
  const asciiMatch = /filename="?([^";]+)"?/i.exec(header);
  return asciiMatch ? asciiMatch[1] : null;
};

export const normalizeObjectPath = (path) => {
  if (!path) return null;
  const trimmedPath = String(path).trim();
  if (!trimmedPath) return null;

  let objectPath = trimmedPath;
  try {
    const url = new URL(trimmedPath);
    objectPath = url.pathname;
  } catch (error) {
    objectPath = trimmedPath;
  }

  objectPath = objectPath.replace(/[?#].*$/, "").replace(/^\/+/, "");
  const publicIndex = objectPath.indexOf("public");
  if (publicIndex >= 0) return objectPath.substring(publicIndex);

  return objectPath;
};

export const blobToDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

export const fetchFileFromApi = async (path) => {
  const objectPath = normalizeObjectPath(path);
  if (!objectPath) return null;

  const response = await ApiService.getWithConfig("/files/download", {
    params: {path: objectPath},
    responseType: "blob",
  });

  const headers = response?.headers || {};
  const disposition = headers["content-disposition"] || headers["Content-Disposition"];
  const contentType = headers["content-type"] || headers["Content-Type"] || "application/octet-stream";
  const fallbackName = objectPath.split("/").pop() || "download";
  const fileName = getFileNameFromDisposition(disposition) || fallbackName;

  return {blob: response.data, fileName, contentType};
};

export const fetchFileDataUrl = async (path) => {
  const file = await fetchFileFromApi(path);
  if (!file) return null;
  const dataUrl = await blobToDataUrl(file.blob);
  return {...file, dataUrl};
};
